import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { getAgencyList, AgencyListReq, AgencyListResponse, AgencyListRes } from "../services/agencyService";
import { QUERY_TIME } from "constants/time";

export const useAgencyQuery = (params: AgencyListReq): UseQueryResult<AgencyListResponse<AgencyListRes[]>> => {
  return useQuery({
    queryKey: ["agencyList"],
    queryFn: () => getAgencyList(params),
    enabled: !!params.shopCd && !!params.token,
		staleTime: QUERY_TIME.ZERO_SECONDS,
    cacheTime: QUERY_TIME.ZERO_SECONDS,
    retry: 3,
  });
};
